import { ButtonContext } from '@root/modules/Sellers/Inquiry/pages/InquiryDetailPage';
import { IDocument } from '@root/modules/Warehouse/interface';
import { Button } from 'antd';
import saveAs from 'file-saver';
import { useContext, useMemo } from 'react';

interface IAttachDown {
  label: string;
  documents?: IDocument[];
}
const _getImageIndi = (document: IDocument) => {
  saveAs(document.url, document.fileName);
};
function AttachDown({ label, documents }: IAttachDown) {
  const _renderFileList = useMemo(() => {
    return (
      <>
        {documents?.map((document, index) => (
          <p
            key={index}
            style={{ marginBottom: '0px', color: '#A6A6A6', cursor: 'pointer' }}
            onClick={() => _getImageIndi(document)}
          >
            {document.fileName}
          </p>
        ))}
      </>
    );
    // });
  }, [documents]);

  const down = () => {
    const arrDoc: any[] = [documents];

    arrDoc.forEach((element: any) => {
      for (let i = 0; i < element.length; i++) {
        saveAs(element[i].url, element[i].fileName);
      }
    });
  };

  const typeButton = useContext(ButtonContext);
  return (
    <div className="attachDown" style={{ marginBottom: '10px' }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}
      >
        <p style={{ marginBottom: '0px' }}>{label}</p>{' '}
        <Button type="primary" onClick={down}>{`${typeButton}`}</Button>
      </div>
      <div
        className="scrollImg"
        style={{
          height: '85px',
          overflowY: 'scroll',
          overflowX: 'scroll',
          width: '320px'
        }}
      >
        {_renderFileList}
      </div>
    </div>
  );
}

export default AttachDown;
